
import api from "./API";

export const AddressService = {
  addNewAddress: async (params) => {
    return await api.post(`/add-customer-address`, { ...params })
  },

}